import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/github.png'
import _imports_1 from './tiktok.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-5f48441d")

_pushScopeId("data-v-5f48441d")
const _hoisted_1 = { class: "root" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, " This is a browser extension that allows you to find the best price per some unit when shopping for groceries. ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" As of right now, it works on many online grocery sites, such as "),
  /*#__PURE__*/_createVNode("b", null, "Target, Shipt, Instacart, Sameday Costco, and SayWeee!")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" I even have some "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://www.tiktok.com/@dwidjaja",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "TikToks"),
  /*#__PURE__*/_createTextVNode(" going over how it works! ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "githubText" }, [
    /*#__PURE__*/_createTextVNode(" Check out the GitHub here: "),
    /*#__PURE__*/_createVNode("a", {
      href: "https://github.com/dwidjaja945/price-per-unit-extension",
      target: "_blank",
      rel: "noopener noreferrer"
    }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_0,
        alt: "github icon"
      })
    ])
  ])
], -1)
const _hoisted_7 = {
  key: 0,
  class: "tiktok-embed",
  cite: "https://www.tiktok.com/@dwidjaja/video/6939312209067609349",
  "data-video-id": "6939312209067609349",
  style: {"max-width":"605px","min-width":"325px"}
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<section data-v-5f48441d><a target=\"_blank\" title=\"@dwidjaja\" href=\"https://www.tiktok.com/@dwidjaja\" data-v-5f48441d>@dwidjaja</a><p data-v-5f48441d><a title=\"fyp\" target=\"_blank\" href=\"https://www.tiktok.com/tag/fyp\" data-v-5f48441d>##fyp</a><a title=\"foryoupage\" target=\"_blank\" href=\"https://www.tiktok.com/tag/foryoupage\" data-v-5f48441d>##foryoupage</a><a title=\"groceries\" target=\"_blank\" href=\"https://www.tiktok.com/tag/groceries\" data-v-5f48441d>##groceries</a><a title=\"softwareengineer\" target=\"_blank\" href=\"https://www.tiktok.com/tag/softwareengineer\" data-v-5f48441d>##softwareengineer</a><a title=\"software\" target=\"_blank\" href=\"https://www.tiktok.com/tag/software\" data-v-5f48441d>##software</a><a title=\"chrome\" target=\"_blank\" href=\"https://www.tiktok.com/tag/chrome\" data-v-5f48441d>##chrome</a><a title=\"hack\" target=\"_blank\" href=\"https://www.tiktok.com/tag/hack\" data-v-5f48441d>##hack</a></p><a target=\"_blank\" title=\"♬ Steven Universe - L.Dre\" href=\"https://www.tiktok.com/music/Steven-Universe-6795585271782967298\" data-v-5f48441d>♬ Steven Universe - L.Dre</a></section>", 1)
const _hoisted_9 = {
  key: 1,
  class: "smallTiktok"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("a", {
  href: "https://www.tiktok.com/@dwidjaja/video/6939312209067609349",
  target: "_blank",
  rel: "noopener noreferrer"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: "tiktok"
  })
], -1)
const _hoisted_11 = { class: "right" }
const _hoisted_12 = { class: "tiktokContainer" }
const _hoisted_13 = {
  class: "tiktok-embed",
  cite: "https://www.tiktok.com/@dwidjaja/video/6944445537663978757",
  "data-video-id": "6944445537663978757",
  style: {"max-width":"605px","min-width":"325px"}
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<section data-v-5f48441d><a target=\"_blank\" title=\"@dwidjaja\" href=\"https://www.tiktok.com/@dwidjaja\" data-v-5f48441d>@dwidjaja</a><p data-v-5f48441d>Bonus points if you can figure out what I’m adding next. <a title=\"fyp\" target=\"_blank\" href=\"https://www.tiktok.com/tag/fyp\" data-v-5f48441d>##fyp</a><a title=\"foryoupage\" target=\"_blank\" href=\"https://www.tiktok.com/tag/foryoupage\" data-v-5f48441d>##foryoupage</a><a title=\"groceries\" target=\"_blank\" href=\"https://www.tiktok.com/tag/groceries\" data-v-5f48441d>##groceries</a><a title=\"software\" target=\"_blank\" href=\"https://www.tiktok.com/tag/software\" data-v-5f48441d>##software</a><a title=\"softwareengineer\" target=\"_blank\" href=\"https://www.tiktok.com/tag/softwareengineer\" data-v-5f48441d>##softwareengineer</a><a title=\"chrome\" target=\"_blank\" href=\"https://www.tiktok.com/tag/chrome\" data-v-5f48441d>##chrome</a><a title=\"hack\" target=\"_blank\" href=\"https://www.tiktok.com/tag/hack\" data-v-5f48441d>##hack</a><a title=\"vue\" target=\"_blank\" href=\"https://www.tiktok.com/tag/vue\" data-v-5f48441d>##vue</a><a title=\"extensions\" target=\"_blank\" href=\"https://www.tiktok.com/tag/extensions\" data-v-5f48441d>##extensions</a></p><a target=\"_blank\" title=\"♬ Lofi - Domknowz\" href=\"https://www.tiktok.com/music/Lofi-6799585653702019073\" data-v-5f48441d>♬ Lofi - Domknowz</a></section>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      (_ctx.showOnSmall)
        ? (_openBlock(), _createBlock("blockquote", _hoisted_7, [
            _hoisted_8
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_9, [
            _hoisted_10
          ]))
    ]),
    _createVNode("div", _hoisted_11, [
      _withDirectives(_createVNode("div", _hoisted_12, [
        _withDirectives(_createVNode("blockquote", _hoisted_13, [
          _hoisted_14
        ], 512), [
          [_vShow, _ctx.showOnSmall]
        ])
      ], 512), [
        [_vShow, _ctx.scriptLoaded]
      ])
    ])
  ]))
})